import axios from "axios";

export default class PosterImageService {
    static createPosterImage(formData: FormData) {
        return new Promise((resolve, reject) => {
            axios
                .post('/poster_images',
                    formData,
                    { headers: {'Content-Type': 'multipart/form-data' }})
                .then((res) => {
                    resolve(res.data);
                })
                .catch(error => reject(error));
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/PosterImageService.ts